export default "__VITE_ASSET__Uppakiax__"